import styled, { css } from 'styled-components';
import { RouterLink as DefaultRouterLink } from '@redux-first-router-link';
import { DeprecatedGrid as Grid, media } from '@simplywallst/ui-core';

export const Wrapper = styled(Grid)`
  margin: 15px;
  h3 {
    margin-bottom: 8px;
  }
`;

export const SnowflakeWrapper = styled.div`
  width: 55px;
  height: 55px;
`;

export const RouterLinkTrendingCompany = styled(DefaultRouterLink)`
  display: grid;
  grid-template-rows: auto auto;
  margin-top: 6px;
  width: 92px;
  height: 100px;
  justify-items: center;
  color: white;
  h4 {
    text-align: center;
  }
`;

export const RouterLinkCommunityIdea = styled(DefaultRouterLink)`
  display: grid;
  max-width: 122px;
  height: 122px;
  color: white;
  position: relative;
  overflow: hidden;
  padding: 8px;
  h4 {
    position: relative;
    align-self: end;
    z-index: 2;
  }
  &:after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;
    ${({ theme }) => css`
      background: linear-gradient(
        200deg,
        ${theme.color.blackRGBA(0)} 0%,
        ${theme.color.blackRGBA(0)} 20%,
        ${theme.color.blackRGBA(0.4)} 50%,
        ${theme.color.blackRGBA(0.8)} 70%,
        ${theme.color.blackRGBA(0.8)} 100%
      );
    `}
  }
`;

export const CoverImage = styled('img')`
  object-fit: cover;
  width: 100%;
  height: 100%;
  transition: all 0.4s ease-out;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 4px;
`;

export const ItemContainer = styled('div')`
  width: 492px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  &:hover {
    background: ${({ theme }) => theme.color.transparentSubtle};
  }

  ${media.mdDown`
    width: 100vw;
  `}
`;
